import React, { useState } from 'react'
import ViewMore from '../../../../Web/Project/SubMenu/Costing/Others/ViewMore';







function MobileOthersData({taskData, getData, projectId,itemsCategory,Division,Activity,Unit}) {
    const [isTaskExpanded, setIsTaskExpanded] = useState(false);
    const [percentOpen, setPercentOpen] = useState(false);
  
    const handleToggle = () => {
      setIsTaskExpanded(!isTaskExpanded);
    };
    // console.log('====================================');
    // console.log(Type,"dddddd");
    // console.log('====================================');
  
    // function DateDiff(createDate, expiryDate) {
    //   createDate = new Date(createDate);
    //   expiryDate = new Date(expiryDate);
    //   let timeDiff = Math.abs(expiryDate.getTime() - createDate.getTime());
    //   let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    //   return diffDays == 0 ? diffDays + 1 : diffDays + 1;
    // }
  
    const userAccess = JSON.parse(localStorage.getItem("userAccess"));
    let MySubTaskCreate = userAccess
      ? userAccess.some(
          (permission) => permission.permissionName == "MySub_task_create"
        )
      : false;
  
  return (
    <div className=' m-[3px] bg-white rounded-md p-1' style={{border:'.5px solid gray'}}>
      <div className=' w-full flex px-1 bg-slate-100 items-center justify-between'>
        <div className=' w-[70%] px-2'>
        {/* <Link
            className="text-sm text-left font-normal text-mainColor-400 line-clamp-1"
            to={`/tasks/view/${taskData?.taskId}`}
            state={{projectId:projectId}}
          >
              {taskData?.designation||""}
          </Link> */}
        </div>
        <div className=' w-[10%]'>
        <div className=" w-full flex gap-2 justify-end px-3 cursor-pointer items-center">
           {/* <div className=" w-[13px] h-[13px] flex justify-center items-center">
           { <Link to="/tasks-plan/subtask/create" state={{ id: taskData?.taskId,projectId:projectId }}>
              <Plus color="#3267FF" />
            </Link>}
            </div>  */}
          </div>
        </div>
        <div className='w-full flex gap-1 justify-end px-1 items-center'>
       
        
                        
        </div>
      </div>
      <div className=' w-full flex  items-center text-xs justify-between mt-1'>
        <div className=''>
            <p className=' font-semibold  '>Category</p>
            {taskData?.category||"-"  }
        </div>
        {/* <div>
            <p className=' font-semibold'>Type</p>
            {taskData?.type==0?"Own":taskData?.type==1?"Rental":"_"}
        </div> */}
        <div>
            <p className=' font-semibold'>Quantity</p>
            {taskData?.quantity || "-"}
        </div>
        <div>
            <p className=' font-semibold'>Amount</p>
            {taskData?.amount || "-"}
        </div>
        <ViewMore data={taskData} id={taskData?.id} projectId={projectId} getData={getData} itemsCategory={itemsCategory} Division={Division} Activity={Activity} Unit={Unit}/>
        
      </div>
            
     
    </div>
  )
}

export default MobileOthersData;